module.exports = __webpack_public_path__ + "img/received.ee89320d.svg";